// allowIndividual=false → company only (venues, catering, transport).
// allowIndividual=true  → vendor chooses company or individual on signup.
const categories = [
  { id: "salla", sq: "Salla", en: "Venues", allowIndividual: false },
  { id: "foto", sq: "Fotografë", en: "Photographers", allowIndividual: true },
  { id: "dekor", sq: "Dekorime", en: "Decoration", allowIndividual: true },
  { id: "katering", sq: "Katering", en: "Catering", allowIndividual: false },
  { id: "muzike", sq: "Muzikë", en: "Music", allowIndividual: true },
  { id: "grim", sq: "Grim & Flokë", en: "Makeup & Hair", allowIndividual: true },
  { id: "fustane", sq: "Fustane", en: "Dresses", allowIndividual: true },
  { id: "transport", sq: "Transport", en: "Transport", allowIndividual: false },
  { id: "ftesa", sq: "Ftesa", en: "Invitations", allowIndividual: true },
  { id: "torta", sq: "Torta", en: "Cakes", allowIndividual: true },
];

export const categoryLabel = (id, lang) => {
  const c = categories.find((x) => x.id === id);
  return c ? c[lang] : id;
};

export default categories;
